import styled, { css } from 'styled-components';

export const Image = styled.img`
  ${({ cursor }) =>
    css`
      cursor: ${cursor};
    `}
`;
